import { TrackedSelect } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { ChevronDown } from 'react-feather';

import { BaseInput } from '../BaseInput';

import * as styles from './Select.module.css';

import type { BaseInputProps } from '../BaseInput';

export type SelectProps = Omit<BaseInputProps<'select'>, 'after'>;

// https://www.figma.com/file/ssGmau7DMZsdIX7F6k0lGk/%E2%9A%A1%EF%B8%8F-Design-System?type=design&node-id=121-3872&mode=design&t=ofKIuOSPHQWXBcWo-0
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({ className, ...props }, ref) => {
  // The <select> element does not have a placeholder property.
  // To simulate a placeholder, we need to add an unselectable default option.
  if (props.placeholder) {
    props.defaultValue = '';
    const placeholderOption = (
      <option disabled hidden value=''>
        {props.placeholder}
      </option>
    );
    props.children = (
      <>
        {placeholderOption}
        {props.children}
      </>
    );
  }
  return (
    <BaseInput
      ref={ref}
      Component={TrackedSelect}
      {...props}
      className={clsx(className, styles.select)}
      after={<ChevronDown />}
    />
  );
});
